import React from 'react';

import { useGlobalLiveMessage } from '../../hooks/useGlobalLiveMessage';
import { useLiveAnnouncer } from '../../hooks/useLiveAnnouncer';

/**
 * Live region that will be updated with the current redux state.
 * There should only be one per layout as only one message can be read at a time.
 *
 * Two live regions are alternated on each message so that a message identical to the previous
 * one is still announced by screen readers, which ignore an unchanged region.
 *
 * @family A11Y
 */
const GlobalLiveMessage = () => {
    const currentA11YMessage = useGlobalLiveMessage();
    const { announce, node } = useLiveAnnouncer({
        enableDoubleRegion: true,
        liveMessageProps: { hidden: true, atomic: 'true' },
    });

    React.useEffect(() => {
        if (currentA11YMessage) {
            announce(currentA11YMessage);
        }
    }, [announce, currentA11YMessage]);

    return node;
};

export { GlobalLiveMessage };
